
import useMetaIcons from "~/mixins/useMetaIcons";
import useGtm from "~/mixins/useGtm";
import MarketingTopBanner from "~/components/common/MarketingTopBanner.vue";
import UiGlobalLoader from "~/components/UI/UiGlobalLoader.vue";
import ImageViewer from "~/components/popups/ImageViewer.vue";

export default {
  components: {
    UiGlobalLoader,
    MarketingTopBanner,
    ImageViewer,
    SystemPopup: () => import("~/components/popups/SystemPopup"),
    AppFooter: () => import("~/components/common/AppFooter"),
    Header: () => import("@/components/common/Header.vue"),
    // SideMenu: () => import("~/components/common/SideMenu.vue"),
    MarketingPopup: () => import("~/components/popups/MarketingPopup.vue"),
  },
  mixins: [
    useMetaIcons,
    useGtm,
  ],
  computed: {
    imageViewer() {
      return this.$store.getters["general/getImageViewer"];
    },
  },
  methods: {
    closeImageViewer() {
      this.$store.dispatch("general/setImageViewer", {
        isOpen: false,
        file: null,
      });
    },
  },
};
